module.exports = __webpack_public_path__ + "static/img/公司18.0505f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司18.jpg
// module id = /knA
// module chunks = 1